export const OrderRequirement = {
    BILLING_INFORMATION: 'loan_requirements.home_address',
    SOCIAL_SECURITY: 'loan_requirements.social_security',
    DATE_OF_BIRTH: 'loan_requirements.date_of_birth',
    PAYMENT_OPTIONS: 'loan_requirements.number_of_pays',
    TERMS_AND_CONDITIONS: 'loan_requirements.terms',
};
